import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-programador',
  templateUrl: './card-programador.component.html',
  styleUrls: ['./card-programador.component.scss']
})
export class CardProgramadorComponent implements OnInit {

  constructor(private router: Router,) { }

  ngOnInit(): void {
  }

  rutas(params: string) {
    this.router.navigate([params]);
  }
}
